import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";

const AccountSettingsContext = createContext();

export function useAccountSettingsContext() {
  let context = useContext(AccountSettingsContext);
  return context;
}

export const AccountSettingsConsumer = AccountSettingsContext.Consumer;

export function AccountSettingsProvider({ AccountSettingsEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState();
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const value = {};

  return (
    <AccountSettingsContext.Provider value={value}>
      {children}
    </AccountSettingsContext.Provider>
  );
}
